var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$auth.ready())?_c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[_c('layout-header'),_c('router-view')],1),_c('layout-footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }